import { render, staticRenderFns } from "./InformationConversation.vue?vue&type=template&id=b1bd05e8&scoped=true"
import script from "./InformationConversation.vue?vue&type=script&lang=js"
export * from "./InformationConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bd05e8",
  null
  
)

export default component.exports